export * from "-!../../../../node_modules/babel-loader/lib/index.js??ref--0-0!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./App.vue?vue&type=template&id=648d4c86&"


//////////////////
// WEBPACK FOOTER
// ./src/js/conf/home/App.vue?vue&type=template&id=648d4c86&
// module id = 562
// module chunks = 30